export class SpinnerModel {
  message: string | undefined;
  showTimer = false;
}
